"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDevOrStagingUrl = void 0;
const shared_1 = require("@clerk/shared");
const { isDevOrStagingUrl } = (0, shared_1.createDevOrStagingUrlCache)();
exports.isDevOrStagingUrl = isDevOrStagingUrl;
